<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="login" />
        <h2 id="pageTitle">{{ 'bss.invalidRequest.title' | translate }}</h2>
        <hr>
        <p>{{ 'bss.invalidRequest.subTitle' | translate }}</p>

    </div>
</div>